<div class="container" id="phone-label" [class.ios]="ios">
  <div class="flags-div" id="flagSelect" (click)="dropdownHandle()"> 
    <img id="flagSelectImg" [src]='selectedCountry.flag' alt="">&nbsp; {{ selectedCountry.ddd }} 
    <yoo-icon id="flagSelectIcon1" *ngIf="!active" icon="caret-down" size="small"></yoo-icon>
    <yoo-icon id="flagSelectIcon2" *ngIf="active" icon="caret-up" size="small"></yoo-icon>
    <span id="flagSelectPipe" class="grey-pipe">|</span>
  </div>

  <li class="flags-drop" [ngClass]="{'active': active}">
    <ul *ngFor="let country of countries" (click)="setMask(country.shorthand)">
      <img [src]="country.flag" alt=""> 
      <span class="country">{{ country.country }}</span>
      <span class="ddd">{{ country.ddd }}</span>
      <span class="icon-div">
        <yoo-icon *ngIf="selectedCountry.shorthandDdd == country.shorthandDdd" icon="check" size="small"></yoo-icon>
      </span>
    </ul>
  </li>
  
  <input class="input-phone"
    type="tel"
    (keyup)="dataEmmit()"
    id="input"
    [placeholder]="selectedCountry.placeHolder"
    name="email"
    autocomplete="off"
    [mask]="selectedCountry.mask"
    [(ngModel)]="phone"
    [class.error]="error"
    [ngClass]="{'input-error': error}"
    #firstInput
  />
</div>